module.exports = __webpack_public_path__ + "b41414bde7d6e53eaf10dc741fa89a3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/deloitte_psp_2022_chart.png
// module id = 1662
// module chunks = 0